export enum REGION_FIELDS {
	ID = "id",
	HEADER = "header",
	LIMIT = "pagination[limit]",
	SEARCH = "search[header]",
}
